module.exports = __webpack_public_path__ + "img/14 Aniamtion 3-squashed.d8f23fc5.jpg";